import { LoaderProgress } from "components/icon/loaderProgress.component";
import { LoggedInPageContainer } from "components/pageLayouts/pageLayouts.styled";
import { useEffect, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAuthStore } from "stores/authStore/authStore";
import { ApplicationList } from "web-apps/company/components/applications/applicationList.component";
import { useApplicationStore } from "web-apps/company/stores/applicationStore/applicationStore";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";

export const ApplicationPage = () => {
  const [authState] = useAuthStore();
  const [companyState] = useCompanyStore();
  const [applicationState] = useApplicationStore();
  const history = useHistory();
  const location = useLocation();

  const havePublicModule = useMemo(() => {
    return (
      companyState.companySettings?.find(
        (s: any) => s.key === "CompanyShowPublicGigModule"
      )?.value == "true"
    );
  }, [companyState.companySettings]);

  useEffect(() => {
    if (havePublicModule) return;

    const params = new URLSearchParams(location.search);
    params.set("page", "Subscription");

    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    });
  }, [havePublicModule, history, location.pathname, location.search]);

  return (
    <LoggedInPageContainer>
      {authState.isLoading ||
      companyState.isLoading ||
      applicationState.isLoading ? (
        <LoaderProgress />
      ) : (
        <ApplicationList />
      )}
    </LoggedInPageContainer>
  );
};
